










import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
/** 柱状图 */
@Component({})
export default class Gcolumn extends Vue {
  @Prop() value: any;
  @Prop({ default: 300 }) height: number = 300;
  @Prop({ default: '数量' }) alias: string = '数量';
  init = false;
  data: object[] = [];

  myHeight: number = this.height;
  label = {
    textStyle: {
      fill: '#aaaaaa',
    },
  };

  tickLine = {
    alignWithLabel: false,
    length: 0,
  };
  scale = [
    {
      dataKey: 'count',
      // tickInterval: 20,
      alias: this.alias,
    },
  ];
  labelInterval = [
    'value',
    {
      useHtml: true,
      htmlTemplate: function htmlTemplate(text: any, item: any) {
        const a = item.point;
        a.percent = String(Math.round(a.percent * 100)) + '%';
        return (
          '<span class="g2-label-item"><p class="g2-label-item-value">' + a.count + '</p></span>'
          // '<p class="g2-label-item-percent">' + a.sales + '</p></div>'
        );
      },
    },
  ];
  @Watch('value')
  watchValue(v: any) {
    if (v.length > 0) {
      if (this.value.length > 0) {
        this.data = this.value;
      }
    }
  }
  mounted() {
    if (this.value.length > 0) {
      this.data = this.value;
    }
    this.setStyle();
    /* fix 柱状图开启:forceFit="true" 超出父控件宽度 */
    setTimeout(() => {
      const e = document.createEvent('Event');
      e.initEvent('resize', true, true);
      window.dispatchEvent(e);
    }, 100);
  }
  setStyle() {
    const id = 'legend-html';
    if (document.getElementById(id)) {
      return;
    }
    const styleTxt = `
          .g2-label-item {
              font-size: 12px;
              text-align: center;
              line-height: 1.5;
          }

          .g2-label-item-value {
              color: #595959;
          }

          .g2-label-item-percent {
              color: #8c8c8c;
          }

        `;
    const style = document.createElement('style');
    style.setAttribute('id', id);
    style.innerHTML = styleTxt;
    document.getElementsByTagName('head')[0].appendChild(style);
  }
}
